import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "content-image-house" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content-reservation" }
const _hoisted_5 = { class: "content-logo-sucess" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    classes: "sucess-request-reserve-modal",
    onClose: $setup.onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "img-house",
            src: $setup.props.house.mainImages[0]
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "icon-succes",
              src: require('@/assets/icons/icon-succes-reserve-quote.svg')
            }, null, 8, _hoisted_6)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "content-text-title" }, "Nice one! Your reservation request has been submitted.", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "content-information" }, "Got a question about your package or the build process? Request a call back from one of our experts!", -1)),
          _createVNode($setup["ContactUsLink"], {
            class: "request",
            animationName: "''",
            toContactUsForm: false,
            text: 'Request a call back',
            isButtonCallBackModal: true,
            linkCalendly: $setup.CALENDLY_BUILD_LINK
          }, null, 8, ["linkCalendly"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}